var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLogoutBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_965_353",
    transform: "scale(0.02)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_965_353",
    width: 50,
    height: 50,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAABmJLR0QA/wD/AP+gvaeTAAABX0lEQVRoge2aPU7DQBCFvyAUiQqJtFwE5RochjIN+blJTsAdKAwUdLQkEWUuABRZiyTgsA/H+K21TxrJxY71Pu3IuztegD4wA5bAh0ksgEnwFq2pgfGqGCsgi5B0pSQ1rCFfMxOtkt5Nkq+TBo38qzKImzKIm5xBbpTBp025OIJmwJmS4LqOSHIuLUmuIHPgDjhXkhxLq2Dj6R4BxhHkEnhh46sALmKSHEHgDzCuILAL88AvMM4gIMC4g8B3mMFPg1IAgQiYVEBgF+aRPZiUQOAATGogUAFTB6QHPG29o60o6u61esB7zXccTbm0WlLlZzglkINrSSognVgQo/Zb7iDR23lnEOlM4grSiYNVZ466z4jNB9dO4xuwAq6BdWyS44zIcm3QyXIHGSmDXUtrhOjLFST/1U1aGcRNnQJZhudhm0b2VHqRLtVMaL8vVRW3Ckg/wJTXnRziNUBEXzz7BOOAODtHOlVVAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogoutBlack);
export default __webpack_public_path__ + "static/media/Icon_Logout_Black.853e86642eb390c6978ea645bbe6d70a.svg";
export { ForwardRef as ReactComponent };